import PLAYNGOSLOTActions from './PLAYNGOSLOTActions'

export default class PLAYNGOTABLEActions extends PLAYNGOSLOTActions {
  constructor(formData) {
    super(formData)
    this.formData = formData

    this.constantTxnData = {
      platform: 'PLAYNGO',
      gameType: 'TABLE',
      gameCode: 'PLAYNGO-TABLE-002',
    }

    this.gameName = 'Deuces Wild MH'
  }
}
